<span (click)="deleteZip(zipCode.id)" class="badge badge-secondary">
    {{ zipCode.label }}
</span>
